import { VehicleReservationState } from './../enums/BookingEnums';
import { NgModel } from '@angular/forms';
import { ReservationCasesByCustomerIDResult, VehicleFeatureModel } from '../../models/Booking/ReservationCasesByCustomerIDResult';
import { EvaluationSummaryModel } from '../Evaluation/EvaluationSummaryModel';

export class MyBookingModel {





  constructor(result: ReservationCasesByCustomerIDResult) {

    this.vehicleImage = 'assets/img/car2.png';
    this.evaluationSummary=result.evaluationSummary;
    this.agencyID=result.agencyID;
    this.loationName=result.locationName;
    this.agencyName=result.fromAgencyName;

    let _feature: VehicleFeatureModel;
    _feature = result.featuresModel


    if (result.vehicleID != null) {
      this.vehicleType = true;
      this.vehicleOdometer = result.odometer + '';
      this.vehicleDoorsNumber = result.numberOfDoors + '';
      this.vehicleStorage = result.luggageCapacity + '';
      //this.vehiclePassengersNumber=result.pass
      this.vehicleConditionUnit = result.hasAirConditions;
      this.vehicleName = result.makeModelYear;
      this.vehicleGearType = result.gearType;
      this.vehiclePetrolType = result.fuelType;
      this.vehiclePassengersNumber=result.passengersName;

    }
    else if (result.makeID != null && result.modelID != null && result.year != null) {
      this.MMYType = true;
      this.vehicleGearTypeList = _feature.gearBox.map(a => a.gearBoxName);
      this.vehiclePetrolTypeList = _feature.fuel.map(a => a.fuelName);
      this.vehiclePassengersNumberList = _feature.passengers.map(a => a.passengersName);
      this.vehicleDoorsNumberList = _feature.numberOfDoors.map(a => a.numberOfDoorsName);
      this.vehicleClassList = _feature.vehicleType.map(a => a.vehicleTypeName);
      this.vehicleStorageList = _feature.storgeCapacity.map(a => a.storgeCapacityName);
    }
    else {
      this.classType = true;
      this.vehicleGearTypeList = _feature.gearBox.map(a => a.gearBoxName);
      this.vehiclePetrolTypeList = _feature.fuel.map(a => a.fuelName);
      this.vehiclePassengersNumberList = _feature.passengers.map(a => a.passengersName);
      this.vehicleDoorsNumberList = _feature.numberOfDoors.map(a => a.numberOfDoorsName);
      this.vehicleClassList = _feature.vehicleType.map(a => a.vehicleTypeName);
      this.vehicleStorageList = _feature.storgeCapacity.map(a => a.storgeCapacityName);
    }

    this.durationUnitName=result.durationUnitName;
    this.classID= result.classID;
    this.makeId= result.makeID;
    this.modelId= result.modelID;
    this.year= result.year;
    this.vehicleID=result.vehicleID;

    this.caseID = result.caseID;
    this.startDate=result.startDate;
    //countDOwn
    this.startDateCoutDown=result.startDateCoutDown;
    this.vehicleName = result.makeModelYear;
    this.distance=result.diffTime;
    //this.countDownInSec = result.diffTime+100000;
    this.grandTotal=result.grandTotal;
    this.vehiclePrice = result.grandTotal;// + result.totalFines + result.totalAccidents + result.totalDamages
    this.vehiclePlateNumber = result.plateNumber;
    this.vehicleClass = result.vehicleClassName;
    this.vehicleBookingNumber = result.bookingNumberFormatted;
    this.vehicleLocation = result.toAgencyName;
    this.outStandingBalance = result.outStandingBalance;

    this.vehicleColors = result.extericColor;
    this.vehicleRankNumber = result.evaluationsCount;
    this.vehicleBookingStatus = result.vehicleReservationState;
    this.DurationInDays = result.durationInDays;
    this.vehicleReservationStateID = result.vehicleReservationStateID;
    this.endDateString=result.endDateString;
    this.endTimeString=result.endTimeString;
    this.startDateString=result.startDateString;
    this.startTimeString=result.startTimeString;

    if (this.vehicleReservationStateID == VehicleReservationState.Confirmed) {
      this.showCountDown = true;

      if(new Date(this.startDateCoutDown)<new Date()){
        this.late=true;
      }
    }


  }
  evaluationSummary:EvaluationSummaryModel;
  agencyID: string;
  agencyName?: string;
  loationName: string;
  startDateCoutDown: string;
  distance: number;
  classType?: boolean = false;
  vehicleType?: boolean = false;
  MMYType?: boolean = false;
  vehicleImage: string;
  vehicleName: string;
  vehicleColors: string;
  vehicleGearType: string;
  vehicleConditionUnit: boolean;
  vehiclePetrolType: string;
  vehiclePassengersNumber: string;
  vehicleDoorsNumber: string;
  vehicleStorage: string;
  vehicleLocation: string;
  vehicleRentalNumber: number;
  vehiclePrice: number;
  vehicleRankNumber: number;
  vehicleRankText: string;
  vehicleTotalReviews: number;
  vehiclePromotionName: string;
  vehiclePromotions: string[];
  vehicleDeposit: string;
  vehicleClass: string;
  hasPromotion: boolean;
  vehiclePlateNumber: string;
  vehicleOdometer: string;
  vehicleBookingNumber: string;
  vehicleBookingStatus: string;
  outStandingBalance: number;
  countDownInSec: number = 0;
  DurationInDays: number;

  vehicleGearTypeList: string[];
  vehiclePetrolTypeList: string[];
  vehiclePassengersNumberList: number[];
  vehicleDoorsNumberList: number[];
  vehicleClassList: string[];
  vehicleStorageList: string[];

  caseID: string;
  showCountDown: boolean;
  vehicleReservationStateID: number;

  classID: number;
  makeId: number;
  modelId: number;
  year: number;
  vehicleID:number;
  startDate?;

  late?:boolean=false;
  durationUnitName?:string;
  grandTotal?:number;

  endDateString: any;
  endTimeString: any;
  startDateString:any;
  startTimeString: any;
}
